import ArticleLayout from '@/components/feature/ArticleLayout';
import { articoloModaUomo } from '@/mocks/articles';

export default function ModaUomoPage() {
  return <ArticleLayout article={articoloModaUomo} />;
}